import { createContext } from 'react'
//Authentication
const authContext = createContext()

export default authContext
